<div
  *ngIf="committeeMeeting"
  ngModelGroup="meetingDetails"
  class="atlas-form mct-gap-27 mct-grid mct-cols-1-2 committee-meeting-grid"
>
  <div class="area-header" >
    <h4>{{ 'committees.edit.committee-meetings.meeting-details.title' | translate | titlecase }}</h4>
  </div>

  <div class="area-left-column" >
    <div class="mb-27">
      <label>{{ 'committees.edit.committee-meetings.meeting-details.meeting-title' | translate | ucfirst }}</label>
      <input wlAutoFocus name="meetingTitle" [(ngModel)]="committeeMeeting.Title" required />
    </div>
    <div class="mct-flex mct-row mct-gap-27"  >
      <div class="mct-flex-1-1-0" >
        <label>{{ 'committees.edit.committee-meetings.meeting-details.date' | translate | ucfirst }}</label>
        <wl-date-selector name="meetingDate" [(ngModel)]="committeeMeeting.MeetingDate" [required]="true"></wl-date-selector>
      </div>
      <div class="mct-flex-1-1-0" >
        <label>{{ 'committees.edit.committee-meetings.meeting-details.time' | translate | ucfirst }}</label>
        <input name="meetingTime" [(ngModel)]="committeeMeeting.MeetingTime" />
      </div>
    </div>
  </div>

  <div class="area-right-column" >
    <label>{{ 'committees.edit.committee-meetings.meeting-details.internal-notes' | translate | ucfirst }}</label>
    <textarea name="internalNotes" pInputTextarea [(ngModel)]="committeeMeeting.Notes"></textarea>
  </div>

  <div class="area-bottom" >
    <label>{{ 'committees.edit.committee-meetings.meeting-details.meeting-purpose' | translate | ucfirst }}</label>
    <input name="meetingPurpose" [(ngModel)]="committeeMeeting.Purpose" />
  </div>
</div>
